export { DefaultRoutingProvider, default, onSettle } from './browser.js';
